import { useState, useRef, useEffect } from "react";

const MultiSelectDropdown = ({
    name,
    value = [],
    onChange,
    options = [],
    optionLabel = "label",
    optionValue = "value",
    className = "",
    placeholder = "Todos",
}) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const selected = Array.isArray(value) ? value : [];

    const allValues = options
        .filter((o) => o[optionValue] !== "all")
        .map((o) => o[optionValue]);

    const allSelected =
        allValues.length > 0 && allValues.every((v) => selected.includes(v));

    const handleToggle = (optVal) => {
        if (optVal === "all") {
            if (allSelected) {
                onChange({ target: { name, value: [] } });
            } else {
                onChange({ target: { name, value: allValues } });
            }
            return;
        }

        const next = selected.includes(optVal)
            ? selected.filter((v) => v !== optVal)
            : [...selected, optVal];

        onChange({ target: { name, value: next } });
    };

    const displayLabel = () => {
        if (selected.length === 0) return placeholder;
        if (allSelected) return placeholder;
        return options
            .filter((o) => selected.includes(o[optionValue]))
            .map((o) => o[optionLabel])
            .join(", ");
    };

    return (
        <div ref={ref} className={`flex w-full h-full ${className}`}>
            <span className="p-float-label w-full md:w-14rem">
                <button
                    type="button"
                    onClick={() => setOpen((v) => !v)}
                    className={`
                        p-dropdown p-component p-inputwrapper
                        !font-input-font-family w-full h-full !text-xs 2xl:!text-base
                        flex items-center
                        ${open ? "p-focus p-inputwrapper-focus" : ""}
                    `}
                    style={{ padding: 0 }}
                >
                    <span className="p-dropdown-label p-inputtext truncate text-left flex-1">
                        {displayLabel()}
                    </span>

                    <span className="p-dropdown-trigger flex items-center justify-center">
                        <span
                            className={`p-dropdown-trigger-icon p-clickable pi pi-chevron-down transition-transform duration-200 ${open ? "rotate-180" : ""
                                }`}
                        />
                    </span>
                </button>

                <label htmlFor={name} />

                {open && (
                    <ul
                        className="p-dropdown-panel p-component absolute z-50 mt-1 w-full max-h-60 overflow-auto"
                        style={{ top: "100%", left: 0 }}
                    >
                        <div className="p-dropdown-items-wrapper">
                            {options.map((opt) => {
                                const val = opt[optionValue];
                                const label = opt[optionLabel];
                                const isAll = val === "all";
                                const isChecked = isAll
                                    ? allSelected
                                    : selected.includes(val);

                                return (
                                    <li
                                        key={val}
                                        onClick={() => handleToggle(val)}
                                        className={`p-dropdown-item !font-input-font-family !text-xs 2xl:!text-base flex items-center gap-2 cursor-pointer py-1.5 px-4 ${isChecked ? "p-highlight" : ""
                                            }`}
                                    >
                                        {/* "Todos" también tiene checkbox para reflejar estado */}
                                        <input
                                            type="checkbox"
                                            readOnly
                                            checked={isChecked}
                                            className="pointer-events-none accent-primary"
                                        />
                                        <span>{label}</span>
                                    </li>
                                );
                            })}
                        </div>
                    </ul>
                )}
            </span>
        </div>
    );
};

export default MultiSelectDropdown;